module.exports = __webpack_public_path__ + "assets/img/28_980.fc7dbbef.jpg";